import React from 'react';

interface Props { }

const ContentLayoutWithoutNavigation = (props: React.PropsWithChildren<Props>) => {
    return (
        <div className='content-without-navigation mb-4'>
            {props.children}
        </div>
    );
}

export default ContentLayoutWithoutNavigation;
